<template>
<div class="material-auto-cut" style="">
  <template  v-for="(item) in data">
    <div :style="imgBoxStyle(item)" :ref="`domRef${item.key}`" :key="item.key">
      <img :src="item.url" :style="imgStyle(item)"/>
    </div>
  </template>
</div>
</template>
<script>
    import util from '@/util.js';
    export default {
        props: {
            data: Array,
            tWidth: [String, Number],
            tHeight: [String, Number]
        },
        data() {
            return {
                loading: false
            }
        },
        computed: {
            dialogValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
        },
        methods: {
            imgStyle(img) {
                let left = img.left > 0 ? 0 : img.left, top = img.top > 0 ? 0 : img.top;
                return `left:${left}px;top: ${top}px;position: absolute;`
            },
            imgBoxStyle(img) {
                let imgLeft = +img.left, imgTop = +img.top, imgRight = +img.right, imgBottom = +img.bottom;
                let isInner = imgLeft >= 0 && imgRight <= this.tWidth;
                let w = img.width;
                if(!isInner){
                    w = imgLeft > 0 ? this.tWidth - imgLeft : this.tWidth;
                    w = imgRight > this.tWidth ? w : w - (w - imgRight);
                }
                isInner = imgTop >= 0 && imgBottom <= this.tHeight;
                let h = img.height;
                if(!isInner){
                    h =  imgTop > 0 ? this.tHeight - imgTop : this.tHeight;
                    h = imgBottom > this.tHeight ? h : h - (h - imgBottom);
                }
                return `width: ${w}px;height: ${h}px;overflow: hidden;position: relative;background-color: RGBA(0,0,0,0)`;
            },
            async _run() {
                let list = this.data, item;
                for(let index in list){
                    item = list[index];
                    let dom = this.$refs[`domRef${item.key}`][0];
                    let width = dom.offsetWidth, height = dom.offsetHeight;
                    let url = await util.html2ImgUrl(dom, width, height).catch((url) => {});
                    this.setImgData(item, width, height, url);
                }
                this.$emit('onAutoCut', this.data)
            },
            setImgData(imgData, width, height, url){
                let minusW = +imgData.width - width, minusH = imgData.height - height;
                imgData.width = width;
                imgData.left = imgData.left < 0 ? 0 : imgData.left;
                imgData.right = imgData.width + imgData.left;
                imgData.height = height;
                imgData.top = imgData.top < 0 ? 0 : +imgData.top;
                imgData.bottom = imgData.height + imgData.top;
                imgData.url = url;
            }
        }
    }
</script>
<style lang="scss">
  .material-auto-cut{
    position: absolute;width:0px;height:0px;overflow: auto
  }
</style>